import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-edit-overview-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ReservationEditOverviewStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = (): ReservationEditOverviewStore => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ReservationEditOverviewStore> = {
    [actionTypes.GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationEditOverviewStore>(initialState(), actionsMap);
